import React from 'react';
import { Typography, Box, Card, CardContent, Chip } from '@mui/material';
import './AdditonalCard.css';
import { docsAuthors } from '../../../utils/docsData';
import { Link } from 'react-router-dom';
import MathText from '../../Math/MathText';
import DocsPreviewImage from '../../Docs/DocsPreviewImage';

const AdditonalCard = (props) => {
    const author = docsAuthors[props.author_id]?.firstName || props.author_id;

    const truncateText = (text, maxLength) => {
        if (text.length <= maxLength) return text;
        const truncated = text.substring(0, maxLength);
        return truncated.substring(0, truncated.lastIndexOf(' ')) + '...';
    };

    return (
        <Card className="additional-card">
            <CardContent className="additional-content">
                {props.category && (
                    <Chip label={props.category} size="small" sx={{ mb: 1, bgcolor: '#2cbb5d', color: '#000' }} />
                )}
                <Typography variant="h5" className="additional-title">{props.title}</Typography>
                <Box className="additional-meta">
                    <Typography variant="body2">{author}</Typography>
                    <Typography variant="body2">{`${props.comments} comments`}</Typography>
                    <Typography variant="body2">{new Date(props.date).toDateString()}</Typography>
                </Box>
                <Typography variant="body1" className="additional-description" component="div">
                    <MathText text={truncateText(props.description, 220)} />
                </Typography>
                <Typography variant="body1" className="read-more">
                    <Link to={`/docs/post/${props.id}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                        Read More
                    </Link>
                </Typography>
            </CardContent>
            <DocsPreviewImage postId={props.id} className="additional-image" alt={`${props.title} preview`} />
        </Card>
    );
};

export default AdditonalCard;
